// Labels and formatting for container image data, shared by the image pages, CVE page and tickets.

// Severity filter values in the API's casing. Trivy rates some findings Unknown.
export const IMAGE_SEVERITY_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'Critical', label: 'Critical' },
  { value: 'High', label: 'High' },
  { value: 'Medium', label: 'Medium' },
  { value: 'Low', label: 'Low' },
  { value: 'Unknown', label: 'Unknown' },
];

// Trivy's status values; the API matches them exactly.
export const TRIVY_STATUS_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'fixed', label: 'Fixed upstream' },
  { value: 'affected', label: 'Affected' },
  { value: 'will_not_fix', label: 'Will not fix' },
  { value: 'fix_deferred', label: 'Fix deferred' },
  { value: 'end_of_life', label: 'End of life' },
  { value: 'under_investigation', label: 'Under investigation' },
  { value: 'unknown', label: 'Unknown' },
];

export const trivyStatusLabel = (status) =>
  TRIVY_STATUS_OPTIONS.find((o) => o.value && o.value === status)?.label || status || null;

const OUTCOMES = {
  applied: { label: 'Applied', tone: 'signal', hint: 'Set the container image’s open findings.' },
  evidence: { label: 'Evidence', tone: 'neutral', hint: 'A push of a tag other than the tracked one. Recorded, findings unchanged.' },
  superseded: { label: 'Superseded', tone: 'low', hint: 'Older than a scan already applied. Findings unchanged.' },
  held: { label: 'Held', tone: 'med', hint: 'An empty report for the current digest. Held until the next scan confirms it.' },
};
export const scanOutcome = (outcome) => OUTCOMES[outcome] || { label: outcome, tone: 'neutral', hint: null };

const MODES = { daily: 'Daily', digest: 'Digest', push: 'Push' };
export const scanModeLabel = (mode) => MODES[mode] || mode;

// "sha256:d05a2c54ed07…" → "d05a2c54ed07"; the full digest goes in a title.
export const shortDigest = (digest) => (digest ? digest.replace(/^sha256:/, '').slice(0, 12) : null);

export const osLabel = (family, name) => [family, name].filter(Boolean).join(' ') || null;

// "registry/project/repository", the image key without the name.
export const imageLocation = (image) => [image.registry, image.project, image.repository].filter(Boolean).join('/');

export const highestImageSeverity = (counts) => {
  if (counts.critical_count > 0) return 'Critical';
  if (counts.high_count > 0) return 'High';
  if (counts.medium_count > 0) return 'Medium';
  if (counts.low_count > 0) return 'Low';
  return null;
};
